import { ChangeDetectorRef, Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Http } from '@angular/http';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../../environments/environment';
import { ApiUrlConstants } from '../../../common/constants/api.constants';
import { TranslateKey } from '../../../common/pipes/translate-key.pipe';
import { Country } from '../../../shared/interface/country.interface';
import { MessageService } from '../../../shared/services/message.service';
import { NotificationType } from '../../enums/notification-types.enum';
import { Address } from '../../interface/address';
import { Option, SearchAddressModelResponse } from '../../interface/search-address-model-response.interface';
import { ShippingAddressInfoConfig } from '../../interface/shipping-address-info-config.interface';
import { AddressService } from '../../services/address.service';
import { ShippingAddressInfoConfigService } from '../../services/shipping-config.service';
import { CommonService } from './../../../shared/services/common.service';
import { AddressError } from './../../enums/address-error.enum';


@Component({
    selector: 'app-search-address',
    templateUrl: '../../templates/template1/views/address/search-address.component.html',
    styleUrls: ['../../templates/template1/themes/default/less/search-address.component.less']
})
export class SearchAddressComponent implements OnInit, OnDestroy {
    searchAddress: Option;
    searchAddressModelResponse: SearchAddressModelResponse;
    searchAddressOptions: Option[];
    showBackButton: boolean;
    prevSearchAddressModelResponse: SearchAddressModelResponse;
    bfpoInstructionsUrl = environment.bfpoInstructionsUrl;
    listBlockHeight = 148;
    typeHeadSelected: boolean;
    hideAddressSubscription: Subscription;
    searchAddressProgress: boolean;
    showErrorMessage: boolean;
    isoCountryCode: string;
    selectedCountrySubscription: Subscription;
    customSelectSubscription: Subscription;
    selectedCountryCode: string;
    sAddressInfoConfig:ShippingAddressInfoConfig

    @Input() countries: Country[];
    @Input() countryCode: string;
    @Input() isFromFboProfile: boolean;
    @Output() rebindAddress = new EventEmitter<Address>();
    @Output() getSearchAddressOptions = new EventEmitter<Option[]>();

    constructor(
        private _addressService: AddressService,
        private _http: Http,
        private _sanitizer: DomSanitizer,
        private cdRef: ChangeDetectorRef,
        private _messageService: MessageService,
        private _commonService: CommonService,
        private _translateService: TranslateService,
        private _translateKey: TranslateKey,
        private _sAddressInfoConfigService:ShippingAddressInfoConfigService
    ) { }
    ngOnInit(): void {
        this.loadDefaultSettings();
    }

    /**
     * @description it used to load default configuration
     * of the current component based on user
     * @date 2019-11-30
     * @private
     * @memberof SearchAddressComponent
     */
    loadDefaultSettings(): void {
        this.isoCountryCode = this.countryCode;
        this.customSelectSubscription = this._messageService.getCustomSelect()
        .subscribe((countryId: string) => {
                const selectedCountry = this.countries
                    .find((x: Country) => x.countryId === parseInt(countryId, 10));
                    if (selectedCountry) {
                        this.isoCountryCode = selectedCountry.isocodeThree.toLowerCase();
                    }
        });
        this.sAddressInfoConfig=this._sAddressInfoConfigService.getSettings(this.isoCountryCode);
        this.getDeviceWidth();
        this.getSelectedCountrybyCustom();
    }

    @HostListener('window:resize', ['$event'])
    onResize($event: Event): void {
        this.getDeviceWidth();
        this.cdRef.detectChanges();
    }

    /**
     * @description it is used to set the searc options block height
     * based on device width
     * @date 2019-11-30
     * @memberof SearchAddressComponent
     */
    getDeviceWidth(): void {
        this.listBlockHeight = window.location.href.indexOf('personalinfo') === -1
            ? 278 : this.listBlockHeight;
        if (window.innerWidth && window.innerWidth <= 767) {
            this.listBlockHeight = window.location.href.indexOf('personalinfo') === -1
            ? 560 : 311;
        }
    }

    /**
     * @description it is used to search address based on entered text
     * @date 2019-11-30
     * @memberof SearchAddressComponent
     */
    searchAddressByDisplayName(selectedOption: Option, showBackButton?: boolean): void {
        this.showBackButton = false;
        if (this.searchAddressModelResponse && selectedOption && selectedOption.displayName) {
            this.searchAddressProgress = true;
            this.searchAddressOptions = [];
            this.showErrorMessage = false;
            this.emitSearchAddressOptions();
            this._addressService.getSearchAddress(this.getSelectedCountry(), null, selectedOption.displayName,
                this.searchAddressModelResponse.uniqueIdentifier).subscribe(response => {
                    if(response && response.validations.length>0){
                        if(response.validations[0].message && response.validations[0].name === AddressError.API_REQUEST_DAILY_LIMIT_EXCEED){
                            let message:String = response.validations[0].message;
                            let limit:String = message.replace(/[^0-9]/g,'');
                            let dailyLimitExceedMessage = this._translateService.get('common.'+'The Daily Limit of ||requestLimit|| is exceeded and address verification will not function')['value'];
                            dailyLimitExceedMessage = this._translateKey.transform(dailyLimitExceedMessage,{requestLimit: limit});
                             this._commonService.setNotification('',dailyLimitExceedMessage,NotificationType.ERROR,0,true,80);

                         }
                    }
                    this.searchAddressProgress = false;
                    this.prevSearchAddressModelResponse = this.searchAddressModelResponse;
                    this.searchAddressModelResponse = response;
                    if (response && response.options && response.options.length) {
                        this.searchAddressOptions = response.options;
                        this.showBackButton = showBackButton;
                    } else if (response && response.address) {
                        this.searchAddressOptions = [];
                        if (!response.address.addressLine1 || !response.address.city) {
                            this.showErrorMessage = true;
                        }
                        this.rebindAddress.emit(response.address);
                        this.searchAddress = null;
                    } else if (response && response.status && response.status.code === 500) {
                        this.searchAddressOptions = [];
                        this.showErrorMessage = true;
                    }
                    this.emitSearchAddressOptions();
                }, error => {
                    this.searchAddressProgress = false;
                });
        }
    }

    /**
     * get selected country details
     */
    private getSelectedCountry(): Country {
        const country = this.countries.find((x: Country) => x.isocodeThree.toLowerCase()
        === this.isoCountryCode.toLowerCase());
        return country;
    }

    /**
     * @description get previous address list
     * @date 2019-11-30
     * @memberof SearchAddressComponent
     */
    showPreviousAddressList(): void {
        this.showBackButton = false;
        if (this.searchAddress && this.searchAddress.displayName) {
            this.searchAddressModelResponse = this.prevSearchAddressModelResponse;
            this.searchAddressByDisplayName(this.searchAddress, true);
        }
    }

    /**
     * @description it used to search address based on entered text
     * @date 2019-11-30
     * @memberof SearchAddressComponent
     */
    onSelectAddress(selectedOption: Option): void {
        if (this.typeHeadSelected) {
            this.searchAddressByDisplayName(selectedOption);
        }
    }

    /**
    * @param  {Option} data
    * @memberof SearchAddressComponent
    * @returns SafeHtml
    */
    autocompleListFormatter = (data: Option): SafeHtml => {
        const html = `${data.displayName}`;
        return this._sanitizer.bypassSecurityTrustHtml(html);
    }

    /**
    * @param  {Option} data
    * @memberof SearchAddressComponent
    * @returns string
    */
    autoCompleteValueFormatter = (data: Option): string => {
        const value = `${data.displayName}`;
        return value;
    }

    /**
     * its soure for auto complete
     * @param  {string} searchText
     * @returns Observable
     */
    observableSource = (searchText: string): Observable<Option[]> => {
        this.showErrorMessage = false;
        if (searchText) {
            const countryCode = this.isoCountryCode;
            const isoCodeTwo = this.getIsoCountryCodeTwo();
            this.searchAddressProgress = true;
            const url = ApiUrlConstants.addressApiUrl + 'search-address?searchTerm='
                   + searchText + '&isocodeTwo=' + isoCodeTwo + '&isocodeThree=' + countryCode;
            return this._http.
                get(url)
                .map(res => {
                    this.searchAddressProgress = false;
                    const response = res.json();
                    this.searchAddressModelResponse = response;
                    if (response && response.options && response.options.length) {
                        return response.options;
                    } else if(response && response.validations.length>0){
                        if(response.validations[0].message && response.validations[0].name === AddressError.API_REQUEST_DAILY_LIMIT_EXCEED){
                            let message:String = response.validations[0].message;
                            let limit:String = message.replace(/[^0-9]/g,'');
                            let dailyLimitExceedMessage = this._translateService.get('common.'+'The Daily Limit of ||requestLimit|| is exceeded and address verification will not function')['value'];
                            dailyLimitExceedMessage = this._translateKey.transform(dailyLimitExceedMessage,{requestLimit: limit});
                             this._commonService.setNotification('',dailyLimitExceedMessage,NotificationType.ERROR,0,true,80);
                             return "No Data";
                         }
                         else{
                             return [];
                         }
                     }
                     else {
                         return [];
                     }
                });
        } else {
            this.searchAddressProgress = false;
            return Observable.of([]);
        }
    }

    /**
     * To rest address options
     * @returns void
     */
    resetAddressOptions(): void {
        this.showErrorMessage = false;
        if (!this.searchAddress) {
            this.showErrorMessage = false;
            this.searchAddressProgress = false;
            this.showBackButton = false;
            this.searchAddressOptions = [];
            this.emitSearchAddressOptions();
        }
    }



    getIsoCountryCodeTwo(): string {
        let isoCodeTwo = 'gb';
        if (this.countries && this.countries.length) {
            const selectedCountry = this.selectedCountryCode ? this.selectedCountryCode : this.isoCountryCode;
            if (selectedCountry) {
                const country = this.countries.find(item => item.isocodeThree.toLowerCase() === selectedCountry.toLowerCase());
                isoCodeTwo = country && country.isocodeTwo ? country.isocodeTwo : isoCodeTwo;
            }
        }
        return isoCodeTwo;
    }
    /**
     * To emit search address options
     * @returns void
     */
    emitSearchAddressOptions(): void {
        this.getSearchAddressOptions.emit(this.searchAddressOptions);
    }
    /**
     * @description wiil get the selected country
     * @date 2020-10-09
     * @private
     * @memberof SearchAddressComponent
     */
    private getSelectedCountrybyCustom(): void {
        this.selectedCountrySubscription = this._messageService.getSelectedCountry()
            .subscribe(countryCode => {
                if (countryCode) {
                    this.selectedCountryCode = countryCode;
                }
            });
    }

    ngOnDestroy(): void {
        if (this.hideAddressSubscription) {
            this.hideAddressSubscription.unsubscribe();
        }
        if (this.selectedCountrySubscription) {
            this.selectedCountrySubscription.unsubscribe();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/customerservice/components/address/search-address.component.ts